@if(isLoading()) {
<app-preloader></app-preloader>
}
<app-notifications></app-notifications>

<div id="insureFlexModalMobile" class="modal" *ngIf="currentStep == 1">
  <a class="close" (click)="onClose()">Cerrar</a>
  <h1>Consultar coberturas</h1>
  <div class="consultarCoberturas">
    <h2>Coberturas</h2>

    <div *ngFor="let coverage of forms; let i = index" class="row">
      <form [formGroup]="coverage">
        <div class="area">
          <label class="checkboxWrapper">
            <input
              type="checkbox"
              formControlName="selected"
              (ngModelChange)="getRecalculateCoverage(coverages[i].special, i)"
            />
            <span class="checkmark"></span>
            <span class="description">{{ coverages[i].coverageName }}</span>
          </label>
        </div>
        <div class="parameters">
          <div>
            <span class="type">Suma asegurada</span>
            <!-- Suma asegurada primer caso -->
            @if(isIfSumOne(coverages[i])){
              <span class="value" data-if="sum-if-one">
                {{
                  isNumberString(coverages[i].maskingSumsInsured)
                    ? (coverages[i].maskingSumsInsured | currency : '' : '')
                    : coverages[i].maskingSumsInsured
                }}
              </span>
            }
            <!-- Suma asegurada segundo caso -->
            @if(isIfSumTwo(coverages[i])){
              <span class="value" data-if="sum-if-two">
                <div class="selectWrapper">
                  <div class="customSelect">
                    <select
                      formControlName="filterValueRangeSum"
                      (ngModelChange)="getRecalculateCoverage(coverages[i].special, i)"
                    >
                      <option *ngFor="let range of coverages[i].modelRange.rangesSums" [value]="range">
                        {{ range | currency : '' : '' }}
                      </option>
                    </select>
                  </div>
                </div>
              </span>
            }
            <!-- Suma asegurada tercer caso -->
            @if(isIfSumThree(coverages[i])){
              <span class="value" data-if="sum-if-three">
                {{ isNumberString(coverages[i].modelRange.rangesSums[0])
                  ? (coverages[i].modelRange.rangesSums[0] | currency : "" : "")
                  : coverages[i].modelRange.rangesSums[0] }}
              </span>
            }
            <!-- Suma asegurada cuarto caso -->
            @if(isIfSumFour(coverages[i])){
              <span class="value" data-if="sum-if-four">
                <div class="controlWrapper">
                  <input type="text" formControlName="filterValueRangeSum" placeholder="Descripción" maxlength="50" (blur)="getRecalculateCoverage(coverages[i].special, i)" />
                </div>
              </span>
            }
          </div>
          <div>
            <span class="type">Deducibles</span>
            @if(isIfDeductOne(coverages[i])){
              <span class="value" data-if="deduct-if-one">
                {{
                  isNumberString(coverages[i].filterValueRangeDeductible)
                    ? (coverages[i].filterValueRangeDeductible
                      | currency : "" : "")
                    : coverages[i].filterValueRangeDeductible
                }}@if(isNumberString(coverages[i].filterValueRangeDeductible)){%}
              </span>
            }
            @if(isIfDeductTwo(coverages[i])){
              <span class="value" data-if="deduct-if-two">
                <div class="selectWrapper">
                  <div class="customSelect">
                    <select
                      formControlName="filterValueRangeDeductible"
                      (ngModelChange)="
                        getRecalculateCoverage(coverages[i].special, i)
                      "
                    >
                      <option
                        *ngFor="
                          let range of coverages[i].modelRange.deductibleRanges
                        "
                        [value]="range"
                      >
                        {{ range | currency : "" : "" }}%
                      </option>
                    </select>
                  </div>
                </div>
              </span>
            }
            @if(isIfDeductThree(coverages[i])){
              <span class="value" data-if="deduct-if-three">
                {{ coverages[i].modelRange.deductibleRanges[0] }}@if(coverages[i].modelRange.deductibleRanges[0] != 'S/D'){%}
              </span>
            }
            @if(isIfDeductFour(coverages[i])){
              <span class="value" data-if="deduct-if-four">
                <div class="controlWrapper">
                  <input
                    type="text"
                    formControlName="filterValueRangeDeductible"
                    placeholder="Valor"
                    maxlength="13"
                    (blur)="getRecalculateCoverage(coverages[i].special, i)"
                  />
                </div>
              </span>
            }
            @if(isIfDeductFive(coverages[i])){
              <span class="value" data-if="deduct-if-five">
                <div class="selectWrapper">
                  <div class="customSelect">
                    <select
                      formControlName="filterValueRangeDeductible"
                      (ngModelChange)="
                        getRecalculateCoverage(coverages[i].special, i)
                      "
                    >
                      <option
                        *ngFor="
                          let range of coverages[i].modelRange.deductibleRanges
                        "
                        [value]="range"
                      >
                        {{ range | currency : "" : "" }}
                      </option>
                    </select>
                  </div>
                </div>
              </span>
            }
            @if(isIfDeductSix(coverages[i])){
              <span class="value" data-if="deduct-if-six">
                {{ coverages[i].filterValueRangeDeductible }}@if(coverages[i].filterValueRangeDeductible != 'S/D'){%}
              </span>
            }
          </div>
        </div>
        <div class="comparison">
          @for(insurerCoverage of coverages[i].insurersCoverage; track insurerCoverage.insurerId; let i = $index){
            <div>
              @if(insurerCoverage.insurerId === 222) {
                <img
                  src="./assets/images/insurance/logo_qualitas.png"
                  alt="Qualitas"
                />
              }@else if(insurerCoverage.insurerId === 14625) {
                <img
                  src="./assets/images/insurance/logo_gnp_seguros.png"
                  alt="GNP Seguros"
                />
              }@else if(insurerCoverage.insurerId === 240819) {
                <img
                  src="./assets/images/insurance/logo_hdi_seguros.png"
                  alt="HDI Seguros"
                />
              }
              <span>
                @if(isCoverageChecked(insurerCoverage)){
                  <i class="customIcon confirmation"></i>
                }
                @if(isCoverageNA(insurerCoverage)){
                  <span>N/A</span>
                }
                @if(isCoverageNAWithRanges(insurerCoverage)){
                  @if(isCoverageModelRangesSumsMoreThanOne(insurerCoverage)){
                    <div class="selectWrapper">
                      <div class="customSelect">
                        <select
                          (change)="
                            updateFilterRangesSums(
                              $event,
                              insurerCoverage.coverageId,
                              insurerCoverage.insurerId
                            )
                          "
                        >
                          <option
                            *ngFor="
                              let range of insurerCoverage?.modelRanges.rangesSums
                            "
                            [value]="range"
                            [selected]="
                              range === insurerCoverage?.filterValueRangeSum
                            "
                          >
                            {{ range }}
                          </option>
                        </select>
                      </div>
                    </div>
                  }
                  @if(isCoverageModelRangesDeductibleMoreThanOne(insurerCoverage)){
                    <div class="selectWrapper">
                      <div class="customSelect">
                        <select
                          (change)="
                            updateFilterDeductibleRanges(
                              $event,
                              insurerCoverage.coverageId,
                              insurerCoverage.insurerId
                            )
                          "
                        >
                          <option
                            *ngFor="
                              let range of insurerCoverage?.modelRanges
                                .deductibleRanges
                            "
                            [value]="range"
                            [selected]="
                              range === insurerCoverage?.filterValueRangeDeductible
                            "
                          >
                            {{ range | currency : "" : "" }}
                          </option>
                        </select>
                      </div>
                    </div>
                  }
                }

              </span>
            </div>
          }
        </div>
      </form>
    </div>
  </div>
  <div class="modalActions index">
    <button class="secondary" (click)="onClose()">Cancelar</button>
    <button class="primary" (click)="createQuote()">Continuar</button>
  </div>
</div>

<div id="insureFlexModalMobile" class="modal" *ngIf="currentStep == 2">
  <a class="close">Cerrar</a>
  <h1>Selección de aseguradora</h1>
  <div class="seleccionAseguradora" *ngIf="quotes">
    @for (insurer of insurers; track insurer) {
      <div class="aseguradora" [attr.data-for]="insurer.insurerId" >
        <div class="logoAndResume">
          <div class="logo">
            <img [src]="insurer.src" [alt]="insurer.alt" />
          </div>
          <div class="resume">
            @if (existPackageList(insurer.insurerId)) {
              <span>{{ getPackageListName(insurer.insurerId) }} </span>
              <span>${{ getPackageLisAmount(insurer.insurerId) | currency : "" : "" }}</span>
              <span>Nº {{ getPackageListNumber(insurer.insurerId) }}</span>
            } @else {
              <span class="na">N/A</span>
            }
          </div>
        </div>

        <!-- Estructura para cada fila -->
        <div class="parameters">
          <form>
            <div class="header">
              <span>Coberturas</span>
              <span>Suma segurada</span>
            </div>
            @for(item of coverages; track item){
              <div class="row">
                <span class="type">{{ item.coverageName }}</span>
                <span class="value">{{ getByCoverageId(insurer.insurerId, item.coverageId) }}</span>
              </div>
            }

            <div class="action">
              @for(insurerQuote of quotes; track insurerQuote.insuranceId){
                @if(insurerQuote.packageList && insurerQuote.insuranceId === insurer.insurerId){
                  <button class="tertiary" (click)="selectedInsurance(insurerQuote.insuranceId)">Seleccionar</button>
                }
              }
            </div>
          </form>
        </div>
      </div>
    }
    <!-- Aseguradora -->
    <!-- <div class="aseguradora" >
      <div class="logoAndResume">
        <div class="logo">
          <img src="./assets/images/insurance/logo_qualitas.png" alt="Qualitas" />
        </div>
        <div class="resume">
          <span>Personalizado</span>
          <span>$162,097.56</span>
          <span>Nº 59557700</span>
        </div>
      </div>
      <div class="parameters">
        <form>
          <div class="header">
            <span>Coberturas</span>
            <span>Suma segurada</span>
          </div>
          <div class="row">
            <span class="type">Daños Materiales</span>
            <span class="value">1,547,108.75 5%</span>
          </div>
          <div class="row">
            <span class="type">Robo Total</span>
            <span class="value">1,547,108.75 10%</span>
          </div>
          <div class="row">
            <span class="type">Gastos Médicos</span>
            <span class="value">100,000.00 0%</span>
          </div>
          <div class="row">
            <span class="type">Gastos Legales</span>
            <span class="value">Amparado 0%</span>
          </div>
          <div class="row">
            <span class="type">Responsabilidad Civil por Daños a Terceros</span>
            <span class="value">2,000,000.00 0%</span>
          </div>
          <div class="row">
            <span class="type">RC Pasajero</span>
            <span class="value">3,160.00 UMA X Pasajero 0%</span>
          </div>
          <div class="row">
            <span class="type">Asistencia Vial</span>
            <span class="value">Amparado 0%</span>
          </div>
          <div class="row">
            <span class="type">Gastos de Transporte Pérdida Total</span>
            <span class="value">Amparado 0%</span>
          </div>
          <div class="row">
            <span class="type">Robo Parcial</span>
            <span class="value">20,000.00 25% </span>
          </div>
          <div class="row">
            <span class="type">Asistencia Satelital</span>
            <span class="value">Amparado 0% </span>
          </div>
          <div class="row">
            <span class="type">MUERTE DEL CONDUCTOR X AA</span>
            <span class="value">100,000.00 0% </span>
          </div>
          <div class="row">
            <span class="type">Gastos X Perdida de Uso X Perdidas Parciales</span>
            <span class="value">Amparado 0% </span>
          </div>
          <div class="row">
            <span class="type">RC Complementaria</span>
            <span class="value"> 1,700,000.00 0% </span>
          </div>
          <div class="row">
            <span class="type">RC Cruzada</span>
            <span class="value">Amparado 0% </span>
          </div>

          <div class="action">
            <button class="tertiary">Seleccionar</button>
          </div>
        </form>
      </div>
    </div> -->

    <!-- <div class="aseguradora">
      <div class="logoAndResume">
        <div class="logo">
          <img src="./assets/images/insurance/logo_gnp_seguros.png" alt="GNP Seguros" />
        </div>
        <div class="resume">
          <span class="na">N/A</span>
        </div>
      </div>

      <div class="parameters">
        <form>
          <div class="header">
            <span>Coberturas</span>
            <span>Suma segurada</span>
          </div>
          <div class="row">
            <span class="type">Daños Materiales</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Robo Total</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Gastos Médicos</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Gastos Legales</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Responsabilidad Civil por Daños a Terceros</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">RC Pasajero</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Asistencia Vial</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Gastos de Transporte Pérdida Total</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Robo Parcial</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Asistencia Satelital</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">MUERTE DEL CONDUCTOR X AA</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Gastos X Perdida de Uso X Perdidas Parciales</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">RC Complementaria</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">RC Cruzada</span>
            <span class="value">N/A</span>
          </div>
        </form>
      </div>
    </div> -->

    <!-- <div class="aseguradora">
      <div class="logoAndResume">
        <div class="logo">
          <img src="./assets/images/insurance/logo_hdi_seguros.png" alt="HDI Seguros" />
        </div>
        <div class="resume">
          <span class="na">N/A</span>
        </div>
      </div>

      <div class="parameters">
        <form>
          <div class="header">
            <span>Coberturas</span>
            <span>Suma segurada</span>
          </div>
          <div class="row">
            <span class="type">Daños Materiales</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Robo Total</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Gastos Médicos</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Gastos Legales</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Responsabilidad Civil por Daños a Terceros</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">RC Pasajero</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Asistencia Vial</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Gastos de Transporte Pérdida Total</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Robo Parcial</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Asistencia Satelital</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">MUERTE DEL CONDUCTOR X AA</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">Gastos X Perdida de Uso X Perdidas Parciales</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">RC Complementaria</span>
            <span class="value">N/A</span>
          </div>
          <div class="row">
            <span class="type">RC Cruzada</span>
            <span class="value">N/A</span>
          </div>
        </form>
      </div>
    </div> -->
  </div>
  <div class="modalActions index">
    <button class="secondary">Volver</button>
    <button class="primary">Cancelar</button>
  </div>
</div>
